var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-list",class:{'align-left': _vm.align === 'left', 'align-right': _vm.align === 'right', 'is-caret': _vm.caret, 'is-levels': _vm.levels, [_vm.themeClass]: _vm.theme, 'is-expanded': _vm.expanded}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }